import { formatPhoneNumber } from '@cian/newbuilding-utils';
import { UIHeading4 } from '@cian/ui-kit';

import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { getPhone } from 'shared/selectors/phone/getPhone';

import styles from './PikPhoneNumber.css';

export const PikPhoneNumber: FC = () => {
  const phone = useSelector(getPhone);

  if (!phone) {
    return null;
  }

  return (
    <a className={styles['pik-number']} data-testid="pik-phone-number" href={`tel:${phone}`}>
      <UIHeading4 color="text-primary-default">{formatPhoneNumber(phone)}</UIHeading4>
    </a>
  );
};
